import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './InActiveOverlay.module.scss';
import { useImage } from '../../../components/ImageContext';
import { DEFAULT_INACTIVE_TIMEOUT } from '../../../constants';
import { useIdle } from '../../../hooks';
import { useGetGameInactivityConfigQuery } from '../../../store/api/game';

export interface InActiveOverlayProps {
  gameId: string;
}

const InActiveOverlay: React.FC<InActiveOverlayProps> = ({ gameId }) => {
  const { t } = useTranslation();
  const loaderImage = useImage('tristar_loader');
  const zzzImage = useImage('inactive-zzz');
  const [blockedByIdle, setBlockedByIdle] = useState(false);
  const [welcomeScreen, setWelcomeScreen] = useState(false);
  const [timeoutValue, setTimeoutValue] = useState(DEFAULT_INACTIVE_TIMEOUT);
  const { data: inactiveData } = useGetGameInactivityConfigQuery(gameId);

  const [isIdle, resetIdle] = useIdle({ timeout: timeoutValue });

  useEffect(() => {
    if (inactiveData?.data?.inactivityTimeout) {
      setTimeoutValue(inactiveData.data.inactivityTimeout * 1000);
    }
  }, [inactiveData?.data?.inactivityTimeout]);

  const message = [
    t('Inactivity Detected'),
    t('Please click "Resume" to continue gameplay'),
  ];

  useEffect(() => {
    if (isIdle && !blockedByIdle) {
      setBlockedByIdle(true);
    }
  }, [blockedByIdle, isIdle]);

  if (!blockedByIdle) return null;

  const handleResume = () => {
    setWelcomeScreen(true);
    setTimeout(() => {
      setBlockedByIdle(false);
      setWelcomeScreen(false);
      resetIdle();
    }, 2000);
  };

  return (
    <div className={styles.overlay}>
      {welcomeScreen ? (
        <>
          <div className={styles.loader}>
            <img src={loaderImage.src} onError={loaderImage.onError} alt="" />
          </div>
          <div className={styles.message}>
            <span className={styles.message__title}>
              {t('Welcome back to Tristar')}
            </span>
          </div>
        </>
      ) : (
        <>
          <img src={zzzImage.src} onError={zzzImage.onError} alt="" />
          <div className={styles.message}>
            <span className={styles.message__title}>{message[0]}</span>
            <span className={styles.message__text}>{message[1]}</span>
          </div>
          <button className={styles.button} onClick={handleResume}>
            {t('Resume')}
          </button>
        </>
      )}
    </div>
  );
};

export default InActiveOverlay;
